import { useState } from 'react';
import PrivacyModal from './PrivacyModal';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    azienda: '',
    servizio: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [privacyError, setPrivacyError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.messaggio.length > 500) {
      return;
    }

    if (!privacyAccepted) {
      setPrivacyError(true);
      return;
    }

    setPrivacyError(false);
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d65i2csc5bvcefa8qme0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          cognome: '',
          email: '',
          telefono: '',
          azienda: '',
          servizio: '',
          messaggio: ''
        });
        setPrivacyAccepted(false);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-6">
            <span className="text-sm font-semibold text-emerald-700">Contattaci</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Richiedi un Preventivo Gratuito
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hai un progetto in mente? Contattaci per una consulenza personalizzata sul <strong>risparmio energetico</strong> e le <strong>energie rinnovabili</strong>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-sm mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Informazioni di Contatto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-1">Sede Operativa</h4>
                    <p className="text-sm text-gray-600">Via Don Luigi Sturzo 181</p>
                    <p className="text-sm text-gray-600">52100 Arezzo (AR)</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-1">Email</h4>
                    <a href="mailto:info.globalenergysrl@gmail.com" className="text-sm text-emerald-600 hover:text-emerald-700 cursor-pointer">
                      info.globalenergysrl@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                    <i className="ri-building-line text-xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-1">Partita IVA</h4>
                    <p className="text-sm text-gray-600">IT-02198440519</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-1">Orari di Apertura</h4>
                    <p className="text-sm text-gray-600">Lun - Ven: 9:00 - 18:00</p>
                    <p className="text-sm text-gray-600">Sabato: Su appuntamento</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-80 rounded-2xl overflow-hidden shadow-sm">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2899.1234567890123!2d11.857!3d43.4519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132bca1234567890%3A0xabcdef1234567890!2sVia+Don+Luigi+Sturzo%2C+181%2C+52100+Arezzo+AR%2C+Italy!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="GLOBAL ENERGY SRL - Via Don Luigi Sturzo 181, 52100 Arezzo"
              ></iframe>
            </div>
          </div>

          <div>
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 shadow-sm">
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome *</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Cognome *</label>
                  <input
                    type="text"
                    name="cognome"
                    value={formData.cognome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Telefono *</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Azienda</label>
                <input
                  type="text"
                  name="azienda"
                  value={formData.azienda}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Servizio di Interesse *</label>
                <select
                  name="servizio"
                  value={formData.servizio}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors"
                >
                  <option value="">Seleziona un servizio</option>
                  <option value="Risparmio Energetico">Risparmio Energetico</option>
                  <option value="Pannelli Fotovoltaici">Pannelli Fotovoltaici</option>
                  <option value="Energie Rinnovabili">Energie Rinnovabili</option>
                  <option value="Strutture in Ferro">Strutture in Ferro</option>
                  <option value="Forniture Industriali">Forniture Industriali</option>
                  <option value="Supporto Tecnico">Supporto Tecnico</option>
                </select>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Messaggio *</label>
                <textarea
                  name="messaggio"
                  value={formData.messaggio}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-900 focus:outline-none focus:border-emerald-500 transition-colors resize-none"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">{formData.messaggio.length}/500 caratteri</p>
              </div>

              <div className="mb-6">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={privacyAccepted}
                    onChange={(e) => {
                      setPrivacyAccepted(e.target.checked);
                      if (e.target.checked) setPrivacyError(false);
                    }}
                    className="mt-1 flex-shrink-0 cursor-pointer"
                  />
                  <span className="text-xs text-gray-600">
                    Ho letto e accetto l&apos;
                    <button
                      type="button"
                      onClick={() => setPrivacyModalOpen(true)}
                      className="text-emerald-600 hover:text-emerald-700 underline cursor-pointer font-medium"
                    >
                      Informativa sul trattamento dei dati personali
                    </button>
                    {' '}ai sensi dell&apos;art. 13 del Reg. (UE) n. 2016/679 e autorizzo il trattamento dei miei dati personali *
                  </span>
                </label>
                {privacyError && (
                  <p className="text-xs text-red-600 mt-1 ml-5">
                    Devi accettare l&apos;informativa sulla privacy per procedere.
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-6 py-4 bg-emerald-600 text-white rounded-lg text-base font-semibold hover:bg-emerald-700 transition-all inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Invio in corso...' : 'Invia Richiesta'}
                <i className="ri-send-plane-line"></i>
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
                  <p className="text-sm text-emerald-700">Messaggio inviato con successo! Ti contatteremo presto.</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-sm text-red-700">Si è verificato un errore. Riprova più tardi.</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>

    <PrivacyModal isOpen={privacyModalOpen} onClose={() => setPrivacyModalOpen(false)} />
    </>
  );
}
